import { cn } from '@/lib/utils'
import React from 'react'

type BoxPropsType = {
  className?: string
  children: React.ReactNode
}

const Box = ({ className, children }: BoxPropsType) => {
  return (
    <div
      id="contact-form"
      className={cn('rounded-xl border-slate-100 bg-white p-4 shadow-lg shadow-slate-200', className)}
    >
      {children}
    </div>
  )
}

export default Box
